import {
  IBundledProduct,
  IBundleUnselectedOption,
  ISelectedOption,
  ISelectedOptionsIndex,
  SelectedBundledProductMetafields,
} from '@shared/types/IBundledProduct';

import {
  findMatchingVariantByOptions,
  getOptionsWithUnavailabilityStatus,
} from './multi-variant-utils';

export const toBundleProductMetafields = (
  id: string,
  bundledProducts: IBundledProduct[],
  selectedOptions: ISelectedOption[],
): SelectedBundledProductMetafields | undefined => {
  const product = bundledProducts.find((v) => v.id === id);
  if (!product) return;
  const { variantId } = findMatchingVariantByOptions(selectedOptions, product.variants) ?? {};
  if (!variantId) return;

  return {
    parentSKU: product.parentSKU,
    variantId,
    qty: product.quantityInBundle,
  };
};

export const optionWithUnavailability =
  (selectedBundleOptions: ISelectedOptionsIndex) =>
  (productOption: IBundledProduct): IBundledProduct => {
    const selectedOptions = selectedBundleOptions[productOption.parentSKU] ?? undefined;
    const options = getOptionsWithUnavailabilityStatus(
      productOption.options,
      productOption.variants,
      selectedOptions,
    );
    return {
      ...productOption,
      options,
    };
  };

export const validateBundledProducts = (
  productOptions: IBundledProduct[],
  selectedOptions: ISelectedOptionsIndex,
): IBundleUnselectedOption[] => {
  return productOptions.reduce<IBundleUnselectedOption[]>((acc, { parentSKU, options }) => {
    const selected = selectedOptions[parentSKU];
    const unselectedOptionNames = options
      .filter((opt) => !selected?.length || !selected.find(({ name }) => name === opt.name))
      .map((opt) => opt.name);

    if (!unselectedOptionNames.length) {
      return acc;
    }

    return [...acc, { parentSKU: parentSKU, unselectedOptionNames }];
  }, []);
};

export const isDefaultTitleOption = (name: string) => /title/i.test(name);
export const isColorOption = (name: string) => /colou?r/i.test(name);
